import { css } from 'linaria';

export const newBathroomCollections = css`
  background-color: var(--background-accent);
  border-radius: 20px;
  padding: 32px;

  @media (--only-mobile) {
    padding: 24px;
  }
`;

export const newBathroomCollectionsHeaderWrapper = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const newBathroomCollectionsTitle = css`
  && {
    font-weight: 700;
    width: unset;
    text-transform: uppercase;
  }
`;

export const newBathroomCollectionsMoreLink = css`
  display: flex;
  column-gap: 4px;
`;

export const newBathroomCollectionsMoreText = css`
  @media (--only-mobile) {
    display: none;
  }
`;

export const newBathroomCollectionsMoreTextMobile = css`
  @media (--from-tablet) {
    display: none;
  }
`;

export const newBathroomCollectionSwiper = css`
  > div {
    @media (--from-tablet) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media (--from-tablet) {
      display: grid;
      column-gap: 16px;
    }
  }
`;

export const newBathroomCollectionSlide = css`
  && {
    @media (--only-mobile) {
      width: 222px;
      margin-right: 16px;
    }
  }
`;

export const newBathroomCollectionImage = css`
  width: 100%;
  border-radius: var(--rounding-l);
  margin-bottom: 8px;
`;

export const newBathroomCollectionSlideInfo = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  row-gap: 4px;
`;